<template>
  <div class="critical-error">
    <div class="critical-error__title">404</div>
    <div class="critical-error__subtitle">Not Found</div>
    <div class="critical-error__text">Такой страницы не существует</div>
  </div>
</template>

<script>
import NOT_FOUND_PAGE from "@/graphql/pages/NotFoundPage.graphql";

export default {
  name: "NotFound",
  async asyncData({ res, apollo, store }) {
    await apollo.defaultClient
      .query({
        query: NOT_FOUND_PAGE,
      })
      .then(({ data }) => {
        store.state.categories = data.categories;
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
        if (data.exchange_rates) store.state.exchange_rates = data.exchange_rates;
      })
      .catch(() => {});
    if (res) {
      res.status(404);
    }
  },
};
</script>

<style lang="stylus">
.critical-error {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100%;

  &__title {
    font-size: 4em;
    line-height: 1;
    color var(--gray-600)
  }

  &__subtitle {
    font-size: 2.24em;
    line-height: 1;
    margin: 10px 0 20px;
    color var(--gray-700)
  }

  &__text {
    font-size: 1.125em;
    max-width: 450px;
    text-align: center;
    color var(--gray-800)
  }
}
</style>
